import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { KeyIcon, CheckCircleIcon } from 'lucide-react';
import { Divider } from './ui/Divider';
export function RitualSection() {
  const features = [{
    title: 'Consulta profunda',
    desc: 'Escuchamos antes de cortar. Siempre.'
  }, {
    title: 'Técnica experta',
    desc: 'Barbería clásica fusionada con arte moderno'
  }, {
    title: 'Productos premium',
    desc: 'Aplicados con intención, no por hábito'
  }, {
    title: 'Atención personalizada',
    desc: 'Aquí nunca eres un número'
  }, {
    title: 'Una experiencia',
    desc: 'No solo un servicio'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="ritual" className="bg-delux-bg py-20 px-4 sm:px-6 lg:px-8" data-id="element-270">
      <div className="max-w-5xl mx-auto" data-id="element-271">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-272">
          <KeyIcon className="w-10 h-10 text-delux-gold mx-auto mb-6" data-id="element-273" />
          <h2 className="font-heading text-4xl md:text-5xl text-delux-gold mb-8" data-id="element-274">
            Presentamos: El Ritual Delux
          </h2>

          <div className="font-body text-lg text-delux-body max-w-3xl mx-auto space-y-6 text-left md:text-center" data-id="element-275">
            <p className="text-xl text-delux-white" data-id="element-276">
              En Barbershop Delux Cut, no agendamos citas.{' '}
              <span className="text-delux-gold font-medium" data-id="element-277">
                Ingeniamos transformaciones.
              </span>
            </p>
            <p data-id="element-278">
              Desde el momento en que cruzas nuestras puertas en Sunshine Plaza,
              algo cambia. El ambiente es diferente — relajado, intencional,
              premium. Esto no es una línea de producción con tijeras y
              conversación vacía.
            </p>
            <p className="font-heading text-2xl text-delux-gold italic py-2" data-id="element-279">
              Este es tu espacio.
            </p>
            <p data-id="element-280">
              Nuestros barberos expertos no solo miran tu cabello. Te miran a ti
              — tu rostro, tu estilo, la versión de ti mismo que estás
              construyendo — y crean un resultado que coincide con tu visión con
              precisión absoluta.
            </p>
            <p className="pt-4" data-id="element-281">
              Lo llamamos El Ritual Delux porque eso es exactamente lo que es:
            </p>
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-16" data-id="element-282">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="flex items-start p-6 bg-delux-card rounded-lg border border-delux-gold/20 hover:border-delux-gold/50 transition-colors" data-id="element-283">
              <CheckCircleIcon className="w-6 h-6 text-delux-gold flex-shrink-0 mt-1 mr-4" data-id="element-284" />
              <div data-id="element-285">
                <h3 className="font-heading text-xl text-delux-white mb-1" data-id="element-286">
                  {feature.title}
                </h3>
                <p className="font-body text-delux-body/80" data-id="element-287">{feature.desc}</p>
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto font-body text-lg text-delux-body" data-id="element-288">
          <p data-id="element-289">
            Ya sea que quieras un fade limpio, un lineado perfecto, un afeitado
            clásico con navaja, o un diseño de barba de precisión — nuestros
            barberos lo ejecutan con la confianza que solo nace del dominio real
            de su oficio.
          </p>
        </motion.div>
      </div>
      <Divider data-id="element-290" />
    </section>;
}